import { Directive, OnDestroy, OnInit, TemplateRef, ViewContainerRef, inject } from '@angular/core';
import { Subscription } from 'rxjs';

import { GlobalService } from '@app/services/global.service';

@Directive({ selector: '[appIsPdoControlMode]' })
export class IsPdoControlModeDirective implements OnInit, OnDestroy {
  private templateRef = inject<TemplateRef<any>>(TemplateRef);
  private viewContainer = inject(ViewContainerRef);
  private globalService = inject(GlobalService);

  private subscription: Subscription;
  private hasView = false;

  ngOnInit(): void {
    this.subscription = this.globalService.isPdoControlMode$.subscribe((isControlMode) => {
      if (isControlMode && !this.hasView) {
        this.viewContainer.createEmbeddedView(this.templateRef);
        this.hasView = true;
      } else if (!isControlMode && this.hasView) {
        this.viewContainer.clear();
        this.hasView = false;
      }
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
